define('SEOImprovements.Home.View', [
    'Home.View',
    'underscore',
    'SC.Configuration'
], function SEOImprovementsHomeView(
     HomeView,
    _,
    Configuration
) {
    'use strict';

    _.extend(HomeView.prototype, {
        getMetaDescription: function getMetaDescription() {
            return Configuration.get('seo.siteDescription');
        },
        getTitle: function getTitle() {
            return Configuration.get('seo.siteTitle') || Configuration.get('siteSettings.displayName');
        }
    });
});
